import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import { Loading } from "components/panels";
import React, { useState } from "react";
import { useCustomQuery, useManualPagination } from "utilities/hookutils";
import { ShowForSidePanel } from "./ShowForSidePanel";

interface SidePanelShowListProps {
  instruction: Partial<server.dto.PaginatedShowInternalInstruction>
}

const SidePanelShowList = (props: SidePanelShowListProps) => {
  const perPage = 5;
  const [instruction, setInstruction] = useState<server.dto.PaginatedShowInternalInstruction>({
    ...props.instruction,
    order: "dateDesc",
    page: 1,
    perPage,
  });

  const api = useCustomQuery({
    queryFn: () => window.CoreApi.Show.PaginatedInternalEnvironment(instruction),
    queryKey: ["shows", instruction],
    onSuccess: (response) => {
      pagination.setPagination(response.data.pagination);
    }
  });

  const paginate = (paginationData: Partial<server.dto.PaginationData>) => {
    setInstruction({ ...instruction, page: paginationData.page, perPage: paginationData.perPage });
  };

  const pagination = useManualPagination(instruction.page || 1, perPage, paginate);
  const items = api.data?.data?.data || [];

  return <div className="flex-column gap">
    <div className="nav-text-regular">{site.currentEnvironment.show.plural}</div>
    {api.isLoading && <Loading />}
    {!api.isLoading && items.length === 0 && <NoDataAvailableDiv />}

    {items.length > 0 && <>
      {items.map(show => <ShowForSidePanel key={show.showId} show={show} />)}
      <div className="flex justify-end">
        {pagination.Component}
      </div>
    </>}
  </div>
};

interface SidePanelShowListExternalProps {
  instruction: Partial<server.dto.ListShowExternalInstruction>
}

const SidePanelShowListExternal = (props: SidePanelShowListExternalProps) => {
  const perPage = 5;
  const [instruction, setInstruction] = useState<server.dto.ListShowExternalInstruction>({
    ...props.instruction,
    page: 1,
    perPage,
  });

  const api = useCustomQuery({
    queryFn: () => window.CoreApi.Show.PaginatedExternalEnvironment(instruction),
    queryKey: ["shows", instruction],
    onSuccess: (response) => {
      pagination.setPagination(response.data.pagination);
    }
  });

  const paginate = (paginationData: Partial<server.dto.PaginationData>) => {
    setInstruction({ ...instruction, page: paginationData.page, perPage: paginationData.perPage });
  };

  const pagination = useManualPagination(instruction.page || 1, perPage, paginate);
  const items = api.data?.data?.data || [];

  return <div className="flex-column gap">
    <div className="nav-text-regular">{site.currentEnvironment.show.plural}</div>
    {api.isLoading && <Loading />}
    {!api.isLoading && items.length === 0 && <NoDataAvailableDiv />}

    {items.length > 0 && <>
      {items.map(show => <ShowForSidePanel key={show.showId} show={{
        ...show,
        title: show.eventName ?? "...",
      }} />)}
      <div className="flex justify-end">
        {pagination.Component}
      </div>
    </>}
  </div>
}

interface VenueSidePanelShowListProps {
  venueId: number
}

export const VenueSidePanelShowList = ({ venueId }: VenueSidePanelShowListProps) =>
  <SidePanelShowList instruction={{
    venueIds: [venueId],
  }} />

interface ProductionSidePanelShowListProps {
  productionId: number
  isInternal: boolean
}

export const ProductionSidePanelShowList = ({ productionId, isInternal }: ProductionSidePanelShowListProps) =>
  isInternal ? <SidePanelShowList instruction={{
    productionIds: [productionId],
  }} /> : <SidePanelShowListExternal instruction={{
    productionIds: [productionId],
  }} />